export default "__VITE_ASSET__CsRld2tp__"